export const MIN_ADMIN_PASSWORD_LENGTH = 8;

const ADMIN_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const getAdminEmailError = (email: string): string | null => {
  const trimmed = email.trim();
  if (!trimmed) return null;
  if (!ADMIN_EMAIL_PATTERN.test(trimmed)) {
    return 'Enter a valid email address';
  }
  return null;
};

export const isValidAdminEmail = (email: string): boolean => getAdminEmailError(email) === null && email.trim().length > 0;

export const getAdminPasswordError = (password: string): string | null => {
  if (!password) return null;
  if (password.length < MIN_ADMIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_ADMIN_PASSWORD_LENGTH} characters`;
  }
  return null;
};

export const isValidAdminPassword = (password: string): boolean =>
  getAdminPasswordError(password) === null && password.length >= MIN_ADMIN_PASSWORD_LENGTH;
